import { isNull } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class OrganizationService extends AbstractService {
	static setup(baseURL, options) {
		instance = new OrganizationService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = APIEndpoints.organizations;
	}

	static getAll(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static getById(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getById(...params);
	}

	static saveAgency(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._saveAgency(...params);
	}

	static uploadImage(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._uploadImage(...params);
	}

	static getJurisdictionPaymentRules(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getJurisdictionPaymentRules(...params);
	}

	static saveJurisdictionPaymentRules(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._saveJurisdictionPaymentRules(...params);
	}

	static getJurisdictionAgencyRules(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getJurisdictionAgencyRules(...params);
	}

	static saveJurisdictionAgencyRules(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._saveJurisdictionAgencyRules(...params);
	}

	static getJurisdictionOfficerRules(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getJurisdictionOfficerRules(...params);
	}

	static saveJurisdictionOfficerRules(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._saveJurisdictionOfficerRules(...params);
	}

	static uploadTaxExemptionDocument(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._uploadTaxExemptionDocument(...params);
	}

	static getDetailsForToken(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getDetailsForToken(...params);
	}

	static getDetailsForSignupToken(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getDetailsForSignupToken(...params);
	}

	_getAll(
		{
			status, pageNumber, displayCount, name, minimalData,
		},
	) {
		const queryParams = {
			status,
			pageNumber,
			displayCount,
			name,
			minimalData,
		};

		return this.get({
			endpoint : this.endpoint,
			queryParams,
		});
	}

	_getById(id) {
		return this.get({
			endpoint : `${this.endpoint}/${id}`,
		});
	}

	_saveAgency({ id, data, queryParams }) {
		return this.put({
			endpoint : `${this.endpoint}/${id}`,
			type     : 'form',
			data,
			queryParams,
		});
	}

	_uploadImage(fileData) {
		const data = new FormData();
		data.append('file', fileData);

		return this.post({
			endpoint : `${this.endpoint}/picture`,
			data,
		});
	}

	_uploadTaxExemptionDocument(fileData) {
		const data = new FormData();
		data.append('file', fileData);

		return this.post({
			endpoint : `${this.endpoint}/taxexemption`,
			data,
		});
	}

	_getJurisdictionPaymentRules() {
		return this.get({
			endpoint : `${APIEndpoints.jurisdictionRules}/payment`,
		});
	}

	_saveJurisdictionPaymentRules(data) {
		return this.put({
			endpoint : `${APIEndpoints.jurisdictionRules}/payment`,
			data,
		});
	}

	_getJurisdictionAgencyRules() {
		return this.get({
			endpoint : `${APIEndpoints.jurisdictionRules}/agency`,
		});
	}

	_saveJurisdictionAgencyRules(data) {
		return this.put({
			endpoint : `${APIEndpoints.jurisdictionRules}/agency`,
			data,
		});
	}

	_getJurisdictionOfficerRules() {
		return this.get({
			endpoint : `${APIEndpoints.jurisdictionRules}/officer`,
		});
	}

	_saveJurisdictionOfficerRules(data) {
		return this.put({
			endpoint : `${APIEndpoints.jurisdictionRules}/officer`,
			data,
		});
	}

	_getDetailsForSignupToken(tokenId) {
		return this.get({
			endpoint : `${this.endpoint}?clientSignupToken=${tokenId}`,
		});
	}

	_getDetailsForToken(token) {
		return this.get({
			endpoint : `${this.endpoint}?organizationToken=${token}`,
		});
	}
}
